import { useState } from 'react';

import { StatusSwitcher, SwitchStatus } from '@/ui/StatusSwitcher';

import { Wrapper } from '../shared';

const Widget = ({
	disabled,
	readonly,
	onChange,
	value,
}) => {
	const [currentValue, setCurrentValue] = useState(() => value);

	const handleChange = (value) => {
		const internalValue = value === 'active' ? 1 : 2;

		onChange(internalValue);
		setCurrentValue(internalValue);
	};

	return (
		<StatusSwitcher
			disabled={disabled || readonly}
			currentStatus={currentValue === 1 ? SwitchStatus.ACTIVE : SwitchStatus.INACTIVE}
			onStatusSwitch={handleChange}
		/>
	);
};

const StatusWidget = (props) => {
	const { value, onChange } = props;

	return (
		<Wrapper value={value} onChange={onChange}>
			<Widget {...props} />
		</Wrapper>
	)
}

export { StatusWidget };
